<template>
  <generic-container
    v-bind:show_plus="true"
    icon="list ol"
    :title="$t('question list')"
    v-on:add="add"
    :wide="true"
  >
    <!-- <h5 class="ui dividing header">{{ $t("question list") }}</h5> -->

    <form-wizard
      title=""
      subtitle=""
      :nextButtonText="$t('next')"
      :backButtonText="$t('back')"
      :finishButtonText="$t('finish')"
      shape="circle"
      @on-complete="onComplete"
      v-if="questions.length > 0"
    >
      <tab-content
        icon="check icon"
        :title="qstn.prompt | truncate(10)"
        v-for="(qstn, qidx) in questions"
        :key="qidx"
      >
        <div class="fields">
          <div class="two wide field">
            <label>{{ $t("order") }}</label>
            <input type="text" v-model="questions[qidx].order" />
          </div>
          <div class="six wide field">
            <label>{{ $t("question") }} {{ qidx + 1 }}</label>
            <input type="text" v-model="questions[qidx].prompt" />
          </div>
          <div class="three wide field">
            <label>{{ $t("maximum answers") }}</label>
            <input type="text" v-model="questions[qidx].max_answers" />
          </div>
          <div class="three wide field">
            <div class="ui toggle checkbox">
              <input
                type="checkbox"
                name="mandatory"
                v-model="questions[qidx].mandatory"
              />
              <label>{{ $t("mandatory") }}</label>
            </div>
          </div>
          <div class="two wide field">
            <label>{{ $t("options") }} </label>
            <div
              class="ui red icon button"
              :data-tooltip="$t('remove')"
              @click="remove(qidx)"
            >
              <i class="trash icon"></i>
            </div>
            <div
              class="ui green icon button"
              :data-tooltip="$t('add answer')"
              @click="add_answer(qidx)"
            >
              <i class="plus icon"></i>
            </div>
          </div>
        </div>
        <div class="ui center aligned message" v-if="qstn.answers.length == 0">
          <div class="content">
            <div class="header">
              {{ $t("no answers added yet!") }}
            </div>
            <p>
              {{
                $t(
                  "you can add answer just by clicking in the green button with plus icon up here",
                )
              }}
            </p>
          </div>
        </div>
        <div class="ui basic blue segment">
          <h5 class="ui header">{{ $t("answers") }}</h5>
          <div class="ui list">
            <div
              class="item"
              v-for="(answer, aidx) in qstn.answers"
              :key="aidx"
            >
              <div class="fields" style="margin-bottom: 0;">
                <div class="one wide field">
                  <label v-if="aidx == 0">{{ $t("order") }}</label>
                  <input
                    type="text"
                    v-model="questions[qidx].answers[aidx].order"
                  />
                </div>
                <div class="one wide field">
                  <label v-if="aidx == 0">{{ $t("weight") }}</label>
                  <input
                    type="text"
                    v-model="questions[qidx].answers[aidx].weight"
                  />
                </div>
                <div class="two wide field">
                  <label v-if="aidx == 0">{{ $t("icon") }}</label>
                  <input
                    type="text"
                    v-model="questions[qidx].answers[aidx].icon"
                  />
                </div>
                <div class="two wide field">
                  <label v-if="aidx == 0">{{ $t("color") }}</label>
                  <input
                    type="text"
                    v-model="questions[qidx].answers[aidx].color"
                  />
                </div>
                <div class="six wide field">
                  <label v-if="aidx == 0">{{ $t("prompt") }}</label>
                  <input
                    type="text"
                    v-model="questions[qidx].answers[aidx].prompt"
                  />
                </div>
                <div class="one wide field">
                  <label v-if="aidx == 0">'</label>
                  <div
                    class="ui red icon button"
                    :data-tooltip="$t('remove')"
                    @click="remove_answer(qidx, aidx)"
                  >
                    <i class="trash icon"></i>
                  </div>
                </div>
                <div class="three wide field">
                  <label v-if="aidx == 0">{{ $t("preview") }} </label>
                  <div
                    class="ui basic icon labeled button"
                    :style="'background-color: ' + answer.color"
                  >
                    <i :class="answer.icon + ' icon'"></i> {{ answer.prompt }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div
          class="ui small basic icon buttons"
          style="margin: 10px"
          v-for="(answer, aidx) in qstn.answers"
          :key="aidx"
        >
          <div class="ui button"><i class="edit icon"></i></div>
          <div class="ui button"><i class="close red icon"></i></div>
          <div class="ui button">
            {{ answer.prompt }}
          </div>
        </div> -->
      </tab-content>
    </form-wizard>
    <div class="ui center aligned message" v-if="questions.length == 0">
      <div class="content">
        <div class="header">
          {{ $t("no questions added yet!") }}
        </div>
        <p>
          {{
            $t(
              "you can add questions just by clicking in the green plus button up here",
            )
          }}
        </p>
      </div>
    </div>

    <!-- <div class="ui bulleted list">
      <div class="item" v-for="(question, qidx) in questions" :key="qidx">
        <div class="fields">
          <div class="field">
            <label>{{ $t("question") }} {{ qidx + 1 }}</label>
            <input type="text" v-model="questions[qidx].prompt" />
          </div>
          <div class="field">
            <label>{{ $t("options") }} </label>
            <div
              class="ui red icon button"
              :data-tooltip="$t('remove')"
              @click="remove(qidx)"
            >
              <i class="trash icon"></i>
            </div>
            <div
              class="ui blue icon button"
              :data-tooltip="$t('add answer')"
              @click="add_answer(qidx)"
            >
              <i class="trash icon"></i>
            </div>
          </div>
        </div>
        <div class="ui four cards">
          <div
            class="ui card"
            v-for="(answer, aidx) in question.answers"
            :key="aidx"
          >
            <div class="content">
              <a class="header">{{ answer.prompt }}</a>
              <div class="description">
                <div class="field">
                  <label>{{ $t("prompt") }}</label>
                  <input
                    type="text"
                    v-model="questions[qidx].answers[aidx].prompt"
                  />
                </div>
                <div class="field">
                  <label>{{ $t("weight") }}</label>
                  <input
                    type="text"
                    v-model="questions[qidx].answers[aidx].weight"
                  />
                </div>                
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
  </generic-container>
</template>

<script>
import GenericContainer from "@/components/GenericContainer";
import { FormWizard, TabContent } from "vue-form-wizard";
import { v4 } from "uuid";

export default {
  components: { GenericContainer, FormWizard, TabContent },
  props: { questions: Array },
  computed: {},
  methods: {
    add() {
      let vm = this;
      let suggestedOrder = vm.questions.length + 1;
      vm.questions.push({
        uuid: v4(),
        order: suggestedOrder,
        prompt: "",
        max_answers: 1,
        mandatory: false,
        answers: [],
      });
    },
    remove(index) {
      this.questions.splice(index, 1);
    },
    add_answer(index) {
      let vm = this;
      let suggestedOrder = vm.questions[index].answers.length + 1;
      vm.questions[index].answers.push({
        uuid: v4(),
        prompt: `${vm.$t("option")} ${suggestedOrder}`,
        icon: "check",
        color: "",
        order: suggestedOrder,
        weight: "",
      });
    },
    onComplete() {
      console.log("completed");
    },
    remove_answer(qidx, aidx) {
      this.questions[qidx].answers.splice(aidx, 1);
    },
  },
};
</script>
